/**
 * 비디오 관련 유틸리티 함수들
 */

/**
 * 제목 길이 제한
 * @param {string} title - 원본 제목
 * @param {number} maxLength - 최대 길이 (기본값: 60)
 * @returns {string} - 잘린 제목
 */
export const truncateTitle = (title, maxLength = 60) => {
  if (title.length <= maxLength) return title;
  return title.substring(0, maxLength) + '...';
};

/**
 * 그리드 열 개수 계산
 * @param {boolean} isMobile - 모바일 여부
 * @param {boolean} isTablet - 태블릿 여부
 * @returns {number} - 그리드 열 개수
 */
export const getGridColumns = (isMobile, isTablet) => {
  if (isMobile) return 2;
  if (isTablet) return 3;
  return 4;
}; 